// extracted by mini-css-extract-plugin
export var brand = "_2t-9";
export var button = "_2t-0";
export var chevron = "_2t-v";
export var chevronButton = "_2t-w";
export var content = "_2t-n";
export var danger = "_2t-g";
export var dangerOutlined = "_2t-h";
export var dark = "_2t-l";
export var darkTheme = "_2t-c";
export var extraSmall = "_2t-4";
export var fullWidth = "_2t-8";
export var ghost = "_2t-d";
export var gray = "_2t-t";
export var icon = "_2t-p";
export var iconButton = "_2t-s";
export var iconButtonBorder = "_2t-x";
export var iconButtonBorderDark = "_2t-y";
export var iconButtonBorderLight = "_2t-z";
export var iconLeft = "_2t-q";
export var iconRight = "_2t-r";
export var large = "_2t-1";
export var light = "_2t-m";
export var medium = "_2t-2";
export var micro = "_2t-5";
export var nano = "_2t-7";
export var outlined = "_2t-k";
export var pending = "_2t-a";
export var primary = "_2t-i";
export var shadow = "_2t-o";
export var small = "_2t-3";
export var solidLight = "_2t-e";
export var solidLightBrand = "_2t-f";
export var spinner = "_2t-u";
export var transparent = "_2t-j";
export var warning = "_2t-b";
export var wideNano = "_2t-6";